var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"columns":_vm.tableTitle,"data":_vm.tableData,"border":"","stripe":"","height":"600"}})}
var staticRenderFns = []

export { render, staticRenderFns }